import { useState } from 'react';
// api
import api from 'api/api';

const useHandleSearch = () => {
  const [timer, setTimer] = useState(null);
  const [stateData, setStateData] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchData = async (url, payload) => {
    if (timer) {
      clearTimeout(timer);
    }

    setTimer(
      setTimeout(async () => {
        setLoading(true);
        try {
          const response = await api.get(url, { params: payload });
          const { status } = response;
          if (status === 200) {
            setStateData( {
              results: response?.data?.results,
              noResults: response?.data?.results.length === 0,
              totalPages: response?.data?.total_pages,
              totalElements: response?.data?.count,
              errors: null
            });
          } else {
            setStateData({
              errors: `Error: ${status}`,
            })
          }
        } catch (err) {
          setStateData({
            errors: `Error: ${err.message}`,
          })
        }
        setLoading(false);
      },500)
    )
  };   

  return { fetchData, stateData, loading };
};

export default useHandleSearch;

